__turbopack_context__.v({
  "accordionSlideOverwrite": "faq-module-scss-module__vycgvq__accordionSlideOverwrite",
  "content": "faq-module-scss-module__vycgvq__content",
  "fadeIn": "faq-module-scss-module__vycgvq__fadeIn",
  "fadeOut": "faq-module-scss-module__vycgvq__fadeOut",
  "faq": "faq-module-scss-module__vycgvq__faq",
  "faqWrap": "faq-module-scss-module__vycgvq__faqWrap",
  "item": "faq-module-scss-module__vycgvq__item",
  "items": "faq-module-scss-module__vycgvq__items",
  "scaleIn": "faq-module-scss-module__vycgvq__scaleIn",
  "scaleOut": "faq-module-scss-module__vycgvq__scaleOut",
  "trigger": "faq-module-scss-module__vycgvq__trigger",
  "zoomIn": "faq-module-scss-module__vycgvq__zoomIn",
  "zoomOut": "faq-module-scss-module__vycgvq__zoomOut",
});
